<template>
  <div class="hris-page">
    <div class="hris-page-inner">
      <div class="hris-page-header">
        <span class="hris-page-eyebrow">Reports</span>
        <h1 class="hris-page-title">Remaining Leaves Report</h1>
        <p class="hris-page-subtitle">Filter and export remaining VL/SL credits by department, status, or employee.</p>
      </div>

      <q-form @submit="onSubmit" class="hris-toolbar">
        <div class="hris-form-field" style="flex: 0 1 180px;">
          <q-input outlined dense color="green" v-model="fromDate" mask="date" :rules="['date']" label="Date From">
            <template v-slot:append>
              <q-icon name="fa fa-calendar-alt" class="cursor-pointer">
                <q-popup-proxy ref="dhDateProxy" transition-show="scale" transition-hide="scale">
                  <q-date v-model="fromDate" @input="() => $refs.dhDateProxy.hide()" color="green"></q-date>
                </q-popup-proxy>
              </q-icon>
            </template>
          </q-input>
        </div>
        <div class="hris-form-field" style="flex: 0 1 180px;">
          <q-input outlined dense color="green" v-model="toDate" mask="date" :rules="['date']" label="Date To">
            <template v-slot:append>
              <q-icon name="fa fa-calendar-alt" class="cursor-pointer">
                <q-popup-proxy ref="dhDateProxy" transition-show="scale" transition-hide="scale">
                  <q-date v-model="toDate" @input="() => $refs.dhDateProxy.hide()" color="green"></q-date>
                </q-popup-proxy>
              </q-icon>
            </template>
          </q-input>
        </div>
        <div class="hris-form-field" style="flex: 0 1 200px;">
          <q-select outlined dense color="green" v-model="status" :options="statusOptions" label="Status" :rules="[formRules.required]"></q-select>
        </div>
        <div class="hris-form-field" style="flex: 0 1 220px;">
          <q-input outlined dense color="green" type="text" v-model="employeeID" label="Employee ID (optional)" lazy-rules></q-input>
        </div>
        <q-btn unelevated class="hris-q-primary" label="Filter" type="submit"></q-btn>
      </q-form>

      <div class="hris-panel">
        <q-table flat :data="data" :columns="columns" row-key="id" :pagination="initialPagination">
          <q-tr slot="body" slot-scope="props" :props="props">
            <q-td key="dept" :props="props">{{ props.row.dept }}</q-td>
            <q-td key="empID" :props="props">{{ props.row.empID }}</q-td>
            <q-td key="firstname" :props="props">{{ props.row.firstname }}</q-td>
            <q-td key="lastname" :props="props">{{ props.row.lastname }}</q-td>
            <q-td key="vlcredit" :props="props">{{ props.row.vlcredit }}</q-td>
            <q-td key="slcredit" :props="props">{{ props.row.slcredit }}</q-td>
            <q-td key="vlused" :props="props">{{ props.row.vlused }}</q-td>
            <q-td key="slused" :props="props">{{ props.row.slused }}</q-td>
            <q-td key="vlremain" :props="props">{{ props.row.vlremain }}</q-td>
            <q-td key="slremain" :props="props">{{ props.row.slremain }}</q-td>
          </q-tr>
          <template v-slot:no-data>
            <div class="hris-empty full-width">No Result Found</div>
          </template>
          <template v-slot:top-right>
            <div class="row q-gutter-sm">
              <q-btn
                unelevated
                class="hris-q-outline"
                icon-right="fas fa-download"
                label="Export to Excel"
                no-caps
                @click="exportTable('xlsx')"
              ></q-btn>
              <q-btn
                unelevated
                class="hris-q-primary"
                icon-right="fas fa-download"
                label="Export to CSV"
                no-caps
                @click="exportTable('csv')"
              ></q-btn>
            </div>
          </template>
        </q-table>
      </div>
    </div>

    <q-dialog v-model="spinner" persistent>
      <div class="hris-loading" style="background: transparent; min-width: 120px;">
        <q-spinner color="green" size="48px"></q-spinner>
      </div>
    </q-dialog>
  </div>
</template>
<script>
import axios from 'axios';
import { exportFile } from 'quasar'

function wrapCsvValue (val, formatFn) {
  let formatted = formatFn !== void 0
    ? formatFn(val)
    : val

  formatted = formatted === void 0 || formatted === null
    ? ''
    : String(formatted)

  formatted = formatted.split('"').join('""')
  /**
   * Excel accepts \n and \r in strings, but some other CSV parsers do not
   * Uncomment the next two lines to escape new lines
   */
  // .split('\n').join('\\n')
  // .split('\r').join('\\r')

  return `"${formatted}"`
}

export default {
  data () {
    return {
        initialPagination: {
            //sortBy: 'desc',
            //descending: false,
            //page: 2,
            rowsPerPage: 50
          },
        fromDate: new Date().toISOString().slice(0, 10).replace("-", "/").replace("-", "/"),
        toDate: new Date().toISOString().slice(0, 10).replace("-", "/").replace("-", "/"),
        status:'',
        employeeID:'',
        statusOptions: ['ACTIVE','HOLD','INACTIVE'],
        columns: [
        { name: 'dept', align: 'center', label: 'DEPARTMENT', field: 'dept' },
        { name: 'empID', align: 'center', label: 'EMPLOYEE ID', field: 'empID' },
        { name: 'firstname', align: 'center', label: 'FIRSTNAME', field: 'firstname' },
        { name: 'lastname', align: 'center', label: 'LASTNAME', field: 'lastname' },
        { name: 'vlcredit', align: 'center', label: 'VL CREDITS', field: 'vlcredit' },
        { name: 'slcredit', align: 'center', label: 'SL CREDITS', field: 'slcredit' },
        { name: 'vlused', align: 'center', label: 'VL USED', field: 'vlused' },
        { name: 'slused', align: 'center', label: 'SL USED', field: 'slused' },
        { name: 'vlremain', align: 'center', label: 'VL REMAIN', field: 'vlremain' },
        { name: 'slremain', align: 'center', label: 'SL REMAIN', field: 'slremain' },
      ],
      data: [],
      spinner:false,
    }
},

created(){
    //this.leaveList()
},

    methods: {
        onSubmit () {
            this.spinner = true
            let formData = new FormData();
                formData.append("fromDate", this.fromDate);
                formData.append("toDate", this.toDate);
                formData.append("status", this.status);
                formData.append("employeeID", this.employeeID);
            axios.create({
                baseURL : this.apiUrl,
                headers : {'Authorization' : `Bearer ${this.token}`}
            }).post('/leave/remaining/credits',formData)
            .then((res) => {
                this.data = res.data.data

                console.log(res.data.data)
                this.spinner = false
            });

        },

    exportTable (fileExtension) {
      // naive encoding to csv format
      const content = [ this.columns.map(col => wrapCsvValue(col.label)) ].concat(
        this.data.map(row => this.columns.map(col => wrapCsvValue(
          typeof col.field === 'function'
            ? col.field(row)
            : row[col.field === void 0 ? col.name : col.field],
          col.format
        )).join(','))
      ).join('\r\n')

      const status =  exportFile(
        `SLVLRemainingReport.${fileExtension}`,
        content,
        `text/${fileExtension}`
      );

      if (status !== true) {
        this.$q.notify({
          message: 'Browser denied file download...',
          color: 'negative',
          icon: 'warning'
        })
      }
    }
  },

}
</script>
